// Bootstrap 5 replacement for toastr
const toastr = ( () => {
  const defaults = {
    closeButton:     true,
    timeOut:         5000,
    extendedTimeOut: 1000,
    tapToDismiss:    false
  };

  // configuration with background class, icon, and text color
  const TOAST_CONFIG = {
    success: {
      bgClass: 'text-bg-success',
      icon: '<i class="fa-solid fa-circle-check text-white fs-1"></i>',
      textColor: 'text-white'
    },
    error: {
      bgClass: 'text-bg-danger',
      icon: '<i class="fa-solid fa-circle-xmark text-white fs-1"></i>',
      textColor: 'text-white'
    },
    warning: {
      bgClass: 'text-bg-warning',
      icon: '<i class="fa-solid fa-triangle-exclamation text-black fs-1"></i>',
      textColor: 'text-black'
    },
    info: {
      bgClass: 'text-bg-info',
      icon: '<i class="fa-solid fa-circle-info text-white fs-1"></i>',
      textColor: 'text-white'
    }
  };

  // animation config
  const animateFrom   = 'top';
  const animateOffset = '-40px';

  function getContainer(){
    let c = document.getElementById( 'toast-container' );
    if( !c ){
      c = document.createElement( 'div' );
      c.id        = 'toast-container';
      c.className = 'toast-container position-fixed end-0 pe-4';
      document.body.appendChild( c );
    }
    return c;
  }

  function getAbsoluteHeight( el ){
    const styles = window.getComputedStyle( el );
    const margin = parseFloat( styles[ "marginTop" ] ) + parseFloat( styles[ "marginBottom" ] );
    return Math.ceil( el.offsetHeight + margin );
  }

  function show( type, message, title, overrides = {} ){
    let hideTimer = null;
    const opts    = Object.assign( {}, defaults, window.toastr.options, overrides );
    const config  = TOAST_CONFIG[ type ] || {
      bgClass: 'text-bg-secondary',
      icon: '',
      textColor: 'text-white'
    };
    const toastEl = document.createElement( 'div' );

    toastEl.className = `toast border-0 ${config.bgClass} mb-4`;
    toastEl.setAttribute( 'role', 'alert' );
    toastEl.setAttribute( 'aria-live', 'assertive' );
    toastEl.setAttribute( 'aria-atomic', 'true' );

    toastEl.innerHTML = `<div class="d-flex justify-content-between w-100">
                           <div class="toast-body d-flex align-items-center gap-3 p-5 pe-0">
                             <div class="toast-icon flex-shrink-0">${ config.icon }</div>
                             <div class="toast-content ${config.textColor}">
                               ${ title ? `<div class="fw-semibold mb-1 fs-5">${ title }</div>` : '' }
                               <div class="fs-base">${ message }</div>
                             </div>
                           </div>
                           ${ opts.closeButton ? `<button type="button" class="btn-close btn-close-white align-self-start m-3" data-bs-dismiss="toast" aria-label="Close"></button>` : '' }
                         </div>`;

    getContainer().appendChild( toastEl );

    // initial animation state
    toastEl.style.position = 'relative';
    toastEl.style[ animateFrom ] = animateOffset;

    // always disable Bootstrap autohide
    const bsToast = new bootstrap.Toast( toastEl, { autohide: false } ); // eslint-disable-line no-undef

    function clearHideTimer(){
      clearTimeout( hideTimer );
      hideTimer = null;
    }

    function scheduleHide( delay ){
      clearHideTimer();
      hideTimer = setTimeout( () => bsToast.hide(), delay );
    }

    // show animation
    toastEl.addEventListener( 'show.bs.toast', () => {
      const container = getContainer();
      const toasts = container.querySelectorAll( '.toast' );

      toasts.forEach( el => {
        el.style.zIndex = ( parseInt( el.style.zIndex || 0, 10 ) + 1 );
      } );
      toastEl.style.zIndex = 1;

      setTimeout( () => {
        const transition = parseFloat( getComputedStyle( toastEl ).transitionDuration ) * 1000 || 150;
        toastEl.style.transition = `all ${ transition * 4 }ms cubic-bezier(0.33, 1, 0.68, 1), opacity ${ transition }ms linear`; // easeOutCubic

        toastEl.style[ animateFrom ] = 0;
      }, 0 );
    }, { once: true } );

    // hide animation
    toastEl.addEventListener( 'hide.bs.toast', () => {
      toastEl.style.marginTop = `-${ getAbsoluteHeight( toastEl ) }px`;
    }, { once: true } );

    // timeOut <= 0 means never auto-hide
    if( opts.timeOut > 0 ){
      scheduleHide( opts.timeOut );
    }

    // hover: pause on enter, restart with extendedTimeOut on leave
    toastEl.addEventListener( 'mouseenter', () => {
      clearHideTimer();
    } );

    // extendedTimeOut = 0 or -1, stay open, user must manually dismiss
    toastEl.addEventListener( 'mouseleave', () => {
      if( opts.extendedTimeOut > 0 ){
        scheduleHide( opts.extendedTimeOut );
      }
    } );

    // tap / click body to dismiss
    if( opts.tapToDismiss ){
      toastEl.addEventListener( 'click', ( e ) => {
        if( !e.target.closest( '.btn-close' ) ){
          clearHideTimer();
          bsToast.hide();
        }
      } );
    }

    toastEl.addEventListener( 'hidden.bs.toast', () => {
      clearHideTimer();
      toastEl.addEventListener( 'transitionend', () => {
        toastEl.remove();
      }, { once: true } );
    } );

    bsToast.show();

    return bsToast;
  }

  return {
    options: {},

    success : ( msg, title, opts ) => show( 'success', msg, title, opts ),
    error   : ( msg, title, opts ) => show( 'error',   msg, title, opts ),
    warning : ( msg, title, opts ) => show( 'warning', msg, title, opts ),
    info    : ( msg, title, opts ) => show( 'info',    msg, title, opts ),

    clear(){
      const c = document.getElementById( 'toast-container' );
      if( !c ) return;
      c.querySelectorAll( '.toast' ).forEach( el => {
        bootstrap.Toast.getInstance( el )?.hide(); // eslint-disable-line no-undef
      } );
    },
  };
} )();

window.toastr = toastr; // legacy code
export default toastr; // ES6 imports
